import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: "#fff",
  },
  title: {
    margin: theme.spacing.unit,
    color: "#fff"
  }
});

const Title = ({ classes }) => {
  return (
    <div className={classes.root}>
      <Avatar aria-label="Receipt" className={classes.avatar}>
        <Typography variant="headline">R</Typography>
      </Avatar>
      <Typography variant="display1" className={classes.title}>Receipt</Typography>
    </div>
  );
};

export default withStyles(styles)(Title);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/Dialog/Title.jsx